import { snakify } from '@/helpers/common';
import { request } from './base';

export interface IUserStorageItem<TInfo = Record<string, unknown>> {
  identifier: string;
  info: TInfo;
}

export interface IUserStorageItemsResponse {
  data: IUserStorageItem[];
}

export const getUserStorageItems = () =>
  request<IUserStorageItemsResponse>({ url: 'user_storage_items' });

export const saveUserStorageItems = (items: IUserStorageItem[]) =>
  request<IUserStorageItemsResponse>({
    url: 'user_storage_items',
    method: 'POST',
    data: snakify({ data: items }),
  });

export const deleteUserStorageItems = (identifiers: string[]) =>
  request<IUserStorageItemsResponse>({
    url: 'user_storage_items/delete',
    method: 'POST',
    data: { data: identifiers },
  });
